import RequestFormCTA, { RequestFormCTAProps } from './RequestFormCTA';

export type { RequestFormCTAProps };
export default RequestFormCTA;
